import { Checkbox, Col, Form, Modal, Row, message } from 'antd';
import React, { useEffect, useState } from 'react';

// Mesmo padrao G3 do ModalConvidarUsuario (funcao + hooks, props visible/
// onClose) - cobre o caso de dar acesso a MAIS unidades pra quem ja tem
// acesso restrito, sem precisar excluir tudo e reconvidar (2026-08-12).
export default function ModalAdicionarUnidade(props) {
  const { visible, registro, unidadesDisponiveis, onClose, adicionarUnidades } = props;

  const [idsFiliaisSelecionadas, setIdsFiliaisSelecionadas] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible) setIdsFiliaisSelecionadas([]);
  }, [visible]);

  const onHandleOk = async () => {
    if (idsFiliaisSelecionadas.length === 0) {
      message.warning('Selecione ao menos uma unidade.');
      return;
    }

    setLoading(true);
    const payload = {
      idEmpresa: registro.idEmpresa,
      idsFiliais: idsFiliaisSelecionadas,
      emailUser: registro.email,
    };
    const sucesso = await adicionarUnidades(payload);
    setLoading(false);
    if (sucesso) {
      setIdsFiliaisSelecionadas([]);
    }
  };

  return (
    <Modal
      visible={visible}
      onCancel={() => onClose()}
      cancelText="Cancelar"
      okText="Adicionar"
      title={`Adicionar unidade para ${registro ? registro.nome || registro.email : ''}`}
      confirmLoading={loading}
      onOk={onHandleOk}
    >
      <Form>
        <Form.Item label="Unidades">
          {unidadesDisponiveis && unidadesDisponiveis.length > 0 ? (
            <>
              <Checkbox
                indeterminate={
                  idsFiliaisSelecionadas.length > 0 &&
                  idsFiliaisSelecionadas.length < unidadesDisponiveis.length
                }
                checked={idsFiliaisSelecionadas.length === unidadesDisponiveis.length}
                onChange={e =>
                  setIdsFiliaisSelecionadas(
                    e.target.checked ? unidadesDisponiveis.map(u => u.id) : []
                  )
                }
                style={{ marginBottom: 8 }}
              >
                Selecionar todas
              </Checkbox>
              <Checkbox.Group
                style={{ width: '100%' }}
                value={idsFiliaisSelecionadas}
                onChange={setIdsFiliaisSelecionadas}
              >
                <Row>
                  {unidadesDisponiveis.map(unidade => (
                    <Col key={unidade.id} span={12}>
                      <Checkbox value={unidade.id}>{unidade.nome}</Checkbox>
                    </Col>
                  ))}
                </Row>
              </Checkbox.Group>
            </>
          ) : (
            <span>Esse usuário já tem acesso a todas as unidades dessa empresa.</span>
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
}
